import { __assign, __rest, __awaiter, __generator } from '../../../node_modules/tslib/tslib.es6.js';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ErrorIcon from '@mui/icons-material/Error';
import React, { useState, useEffect } from 'react';
import QRCode from 'react-qr-code';
import { TABLET_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from '../../../utils/constants/Constants.js';
import _get from 'lodash/get';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { Typography } from '@mui/material';
import { ButtonLoadingEllipsis } from '../Loading/index.js';
import '../../../Components/Button/BackButton.js';
import { Button } from '../../../Components/Button/Button.js';
import '../../../Components/Button/CloseButton.js';
import '../../../Components/Button/CustomDtcBagButton.js';
import '../../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../../types/filters.js';
import '../../../utils/assetUtils.js';
import '../../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import 'he';
import '../../../utils/broadcast.js';
import { formatPhoneNumber } from '../../../utils/formatPhoneNumber.js';
import 'lodash/isEqual';
import 'lodash/orderBy';
import '../../../types/Campaign.js';
import '../../../types/product.js';
import '../../../api/graphQl/brand.js';
import '../../../api/graphQl/product.js';
import '@brandclub/types';

var _a, _b;
var QRCodeContainer = styled(Grid)((_a = {},
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        display: 'none',
    },
    _a));
var BCPhoneInputVariant;
(function (BCPhoneInputVariant) {
    BCPhoneInputVariant["DEFAULT"] = "default";
    BCPhoneInputVariant["XS"] = "xs";
    BCPhoneInputVariant["SM"] = "sm";
    BCPhoneInputVariant["DRAWER"] = "drawer";
    BCPhoneInputVariant["DRAWER_MOBILE"] = "drawer-mobile";
})(BCPhoneInputVariant || (BCPhoneInputVariant = {}));
var variantStyles = (_b = {},
    _b[BCPhoneInputVariant.DEFAULT] = {
        container: {
            maxWidth: '100%',
        },
        inputContainer: {
            height: 56,
            minWidth: 345,
            borderWidth: 1.5,
        },
        input: {
            fontSize: 20,
            margin: '0 0 0 10px',
        },
        prefix: {
            fontSize: 18,
            marginLeft: 20,
        },
        button: {
            fontSize: 18,
            width: 134,
            height: 46,
        },
    },
    _b[BCPhoneInputVariant.XS] = {
        container: {
            maxWidth: 269,
        },
        inputContainer: {
            height: 39.1,
            minWidth: 269,
            borderWidth: 1,
        },
        input: {
            fontSize: 14,
            margin: '0 0 0 7px',
        },
        prefix: {
            fontSize: 14,
            marginLeft: 7,
        },
        button: {
            fontSize: 14,
            width: 91,
            height: 29,
        },
    },
    _b[BCPhoneInputVariant.SM] = {
        container: {
            maxWidth: 314,
        },
        inputContainer: {
            height: 46.4,
            minWidth: 314,
            borderWidth: 1.5,
        },
        input: {
            fontSize: 14,
            margin: '0 0 0 7px',
        },
        prefix: {
            fontSize: 14,
            marginLeft: 7,
        },
        button: {
            fontSize: 14,
            width: 106,
            height: 35,
        },
    },
    _b[BCPhoneInputVariant.DRAWER] = {
        container: {
            maxWidth: 345,
        },
        inputContainer: {
            height: 55,
            minWidth: 345,
            borderWidth: 1.5,
        },
        input: {
            fontSize: 16,
            margin: '0 0 0 10px',
        },
        prefix: {
            fontSize: 16,
            marginLeft: 20,
        },
        button: {
            fontSize: 16,
            width: 134,
            height: 46,
        },
    },
    _b[BCPhoneInputVariant.DRAWER_MOBILE] = {
        container: {
            maxWidth: 288,
        },
        inputContainer: {
            height: 49,
            minWidth: 288,
            borderWidth: 1.5,
            padding: '0 3px',
        },
        input: {
            fontSize: 14,
            margin: '0 0 0 7px',
        },
        prefix: {
            fontSize: 14,
            marginLeft: 7,
        },
        button: {
            fontSize: 14,
            width: 80,
            height: 40,
        },
    },
    _b);
var InputContainer = styled(Grid, {
    shouldForwardProp: function (prop) { return !['variant'].includes(prop.toString()); },
})(function (_a) {
    var _b, _c;
    var variant = _a.variant, theme = _a.theme;
    var variantStyle = variantStyles[variant];
    return __assign(__assign({ width: '100%', position: 'relative' }, variantStyle.container), { '.textme_header': (_b = {
                fontWeight: 600,
                color: theme.palette.primary.main,
                fontSize: 18,
                marginBottom: 10
            },
            _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                display: 'none',
            },
            _b), '.textme_input': __assign(__assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', borderStyle: 'solid', borderColor: theme.palette.primary.main, borderRadius: 100, backgroundColor: '#fff', padding: '0 5px', maxWidth: 400, width: '100%', boxSizing: 'border-box' }, variantStyle.inputContainer), { '.text_prefix': __assign(__assign({ color: theme.palette.primary.main, fontWeight: 500 }, variantStyle.prefix), { '&.sent': {
                    display: 'none',
                } }), input: __assign(__assign({ fontFamily: 'Poppins', width: 0, flex: 1, color: theme.palette.primary.main, backgroundColor: '#fff', fontWeight: 500, border: 0, outline: 'none' }, variantStyle.input), { '&.sent': {
                    display: 'none',
                }, '&::placeholder': {
                    color: '#a7afc4',
                } }), '.text_button': __assign(__assign({ cursor: 'pointer', fontWeight: 500, marginRight: 0, border: 0, backgroundColor: theme.palette.primary.main, color: '#fff', borderRadius: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s ease' }, variantStyle.button), { '&.sent': {
                    width: '100%',
                } }) }), '.textme_button_group': (_c = {
                display: 'none'
            },
            _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                display: 'flex',
                marginTop: 15,
                gap: '10px',
                button: {
                    borderWidth: 1,
                    borderStyle: 'solid',
                    outline: 'none',
                    borderRadius: 100,
                    height: 40,
                    fontSize: 16,
                    '&.download': {
                        borderColor: theme.palette.primary.main,
                        color: theme.palette.primary.main,
                        background: 'rgba(158,224,208,.2)',
                        flex: 1,
                    },
                    '&.text_link': {
                        flex: 1,
                        borderColor: theme.palette.primary.main,
                        color: brandclub_colors.white,
                        background: theme.palette.primary.main,
                    },
                },
            },
            _c) });
});
var ErrorMessage = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    if (!children) {
        return null;
    }
    var lineHeight = 1.5;
    return (React.createElement(Typography, __assign({}, props, { sx: {
            color: '#ff534a',
            backgroundColor: 'rgba(255, 83, 74, 0.05)',
            fontSize: 14,
            marginTop: 2.5,
            padding: '7px 12px 7px 9px',
            display: 'flex',
            alignItems: 'flex-start',
            width: 'max-content',
            borderRadius: 1,
            fontWeight: 600,
            lineHeight: lineHeight,
        } }),
        React.createElement(Box, { component: "span", display: "flex", alignItems: "center", height: "".concat(lineHeight, "em") },
            React.createElement(ErrorIcon, { sx: { paddingRight: 0.75, fontSize: 18 } })),
        children));
};
var getSendStatusMessage = function (sendStatus, defaultMessage) {
    switch (sendStatus) {
        case 'sending':
            return (React.createElement(React.Fragment, null,
                "Sending",
                React.createElement(ButtonLoadingEllipsis, { baseFontSize: 17 })));
        case 'sent':
            return 'Text sent!';
        default:
            return defaultMessage;
    }
};
var BrandclubPhoneInput = function (_a) {
    var _b;
    var handleSendText = _a.handleSendText, qrCodeUrl = _a.qrCodeUrl, _c = _a.hasHeader, hasHeader = _c === void 0 ? true : _c, _d = _a.buttonText, buttonText = _d === void 0 ? 'Send Text' : _d, variant = _a.variant, onTextSent = _a.onTextSent, userProfile = _a.userProfile;
    var _e = useState(''), phoneNumber = _e[0], setPhoneNumber = _e[1];
    var _f = useState('normal'), sendStatus = _f[0], setSendStatus = _f[1];
    var desktopView = useMediaQuery("(min-width:".concat(TABLET_SCREEN_SIZE, "px)"));
    var mobileView = useMediaQuery("(max-width:".concat(MOBILE_SCREEN_SIZE, "px)"));
    var isSignedIn = !!userProfile;
    var userPhoneNumber = userProfile === null || userProfile === void 0 ? void 0 : userProfile.phoneNumber;
    var variantToUse = variant
        ? variant
        : desktopView
            ? BCPhoneInputVariant.DEFAULT
            : mobileView
                ? BCPhoneInputVariant.XS
                : BCPhoneInputVariant.SM;
    useEffect(function () {
        if (sendStatus === 'sent') {
            // Reset the send status after 3 seconds
            setTimeout(function () {
                setSendStatus('normal');
                setPhoneNumber('');
            }, 3000);
        }
    }, [sendStatus]);
    var sendText = function () { return __awaiter(void 0, void 0, void 0, function () {
        var number, res, sentStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    number = userPhoneNumber !== null && userPhoneNumber !== void 0 ? userPhoneNumber : phoneNumber;
                    number = number.replace(/\D/g, ''); // removes all non-digit characters
                    setSendStatus('sending');
                    return [4 /*yield*/, handleSendText(number)];
                case 1:
                    res = _a.sent();
                    sentStatus = _get(res, ['waitListEntry', 'textInvitationStatus']);
                    if (sentStatus === 'sent') {
                        if (onTextSent)
                            onTextSent();
                        setSendStatus('sent');
                    }
                    else {
                        setSendStatus('failed');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    setSendStatus('failed');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Box, { display: "flex", flexDirection: "column" },
        qrCodeUrl && (React.createElement(QRCodeContainer, null,
            React.createElement(QRCode, { value: qrCodeUrl, fgColor: "#181d56", size: 95 }))),
        React.createElement(InputContainer, { container: true, flexDirection: 'column', variant: variantToUse },
            hasHeader && React.createElement("div", { className: "textme_header" }, "Download the app to access rewards"),
            isSignedIn && userPhoneNumber ? (React.createElement(Button, { sx: (_b = {
                        height: 50,
                        maxWidth: 355,
                        width: '100%',
                        fontSize: 16,
                        alignSelf: 'center'
                    },
                    _b["@media (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                        height: 40,
                        fontSize: 12,
                        maxWidth: 300,
                    },
                    _b), onClick: ['normal', 'failed'].includes(sendStatus) ? sendText : undefined, disabled: sendStatus === 'sending' }, getSendStatusMessage(sendStatus, "Text link to ".concat(formatPhoneNumber(userPhoneNumber))))) : (React.createElement("div", { className: "textme_input" },
                React.createElement("div", { className: "text_prefix ".concat(sendStatus) }, "+1"),
                React.createElement("input", { className: "phone_input ".concat(sendStatus), name: "phone_number", placeholder: "Phone number", value: phoneNumber, type: "tel", onChange: function (e) {
                        setSendStatus('normal');
                        setPhoneNumber(e.target.value);
                    } }),
                React.createElement(Button, { className: "text_button ".concat(sendStatus), style: {
                        minWidth: 'max-content',
                    }, onClick: ['normal', 'failed'].includes(sendStatus) ? sendText : undefined, disabled: sendStatus === 'sending' }, getSendStatusMessage(sendStatus, buttonText))))),
        React.createElement(ErrorMessage, null, sendStatus === 'failed' && 'Failed to send text. Please try again.')));
};

export { BCPhoneInputVariant, BrandclubPhoneInput as default };
//# sourceMappingURL=index.js.map
